import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns'
import generatePicker from 'antd/es/date-picker/generatePicker'

import {
  PickerDateProps,
  RangePickerProps as AntdRangePickerProps
} from 'antd/lib/date-picker/generatePicker'

export type DatePickerProps = PickerDateProps<Date>
export type RangePickerProps = AntdRangePickerProps<Date>

export const DatePicker = generatePicker<Date>(dateFnsGenerateConfig)
